<div class="border-1 bg-white p-2 border-round-lg border-gray-400">
  <h3 class="bold-text my-1">{{ task.vehicleReg }}</h3>
  <p class="text-gray-700">{{ task.vehicle }}</p>

  <div class="flex gap-1 align-items-center mb-2" *ngIf="!isVME">
    <p-inputSwitch
      [disabled]="!task.isCarryoverPossible || isAlreadyScheduledForToday"
      [ngModel]="canCarryover"
      (ngModelChange)="handleCarryoverToggle($event)"
    ></p-inputSwitch>
    <span>Carryover this vehicle?</span>
  </div>

  <vertical-dots-container [position]="'start'" [narrowDots]="true" iconSize="small">
  </vertical-dots-container>

  <vertical-dots-container
    [position]="'end'"
    [narrowDots]="true"
    [iconClass]="'fa fa-circle'"
    iconSize="small"
  >
    <div class="-mt-3">
      <div>
        <p class="bold-text mt-0">{{ task.pickupAddress }}</p>
        <schedule-dropdown
          [title]="'Select a Pick-up Schedule'"
          [availableDates]="pickupTimeWindows"
          (scheduleSelected)="handlePickupScheduleSelected($event)"
          [selectedSchedule]="task.supplierPickupWindow"
          [showCalendar]="showPickupCalendar"
          (showCalendarChange)="pickupCalendarToggled($event)"
          [disabled]="isExistingPickupOnPreviousDay && !isVME"
        ></schedule-dropdown>
        <p class="text-gray-700">
          Customer Window: {{ task.customerPickupEarliest | datex : 'ddd, DD MMM, HH:mm' }} -
          {{ task.customerPickupLatest | datex : 'ddd, DD MMM, HH:mm' }}
        </p>
      </div>

      <div class="mt-4">
        <p class="bold-text mt-0">{{ task.dropoffAddress }}</p>
        <schedule-dropdown
          [title]="'Select a Drop-off Schedule'"
          [availableDates]="dropoffTimeWindows"
          (scheduleSelected)="handleDropoffScheduleSelected($event)"
          [selectedSchedule]="task.supplierDropoffWindow"
          [disabled]="isDropoffScheduleDisabled() || (isExistingDropoffOnPreviousDay && !isVME)"
          [showCalendar]="showDropoffCalendar"
          (showCalendarChange)="dropoffCalendarToggled($event)"
        ></schedule-dropdown>
        <p class="text-gray-700">
          Customer Window: {{ task.customerDropoffEarliest | datex : 'ddd, DD MMM, HH:mm' }} -
          {{ task.customerDropoffLatest | datex : 'ddd, DD MMM, HH:mm' }}
        </p>
      </div>
    </div>
  </vertical-dots-container>
</div>
